/**
 * The placeholder body every routed surface wears until its own prompt fills it.
 *
 * It is deliberately a real surface header plus an empty state, not a "TODO": the header is
 * the composition rule Stage 3 set (surface header → content), and the empty state is the
 * house voice for a thing that isn't there yet.
 */

import { EmptyState, SurfaceHeader } from '@atlas-nook/design-system';
import type { JSX, ReactNode } from 'react';

import { useT } from '../i18n/I18nProvider.js';
import type { MessageKey } from '../i18n/I18nProvider.js';

export function SurfaceFrame({
  kicker,
  title,
  meta,
  children,
}: {
  kicker?: MessageKey;
  title: MessageKey;
  meta?: ReactNode;
  children?: ReactNode;
}): JSX.Element {
  const t = useT();

  return (
    <>
      <SurfaceHeader
        {...(kicker !== undefined ? { kicker: t(kicker) } : {})}
        title={t(title)}
        {...(meta !== undefined ? { meta } : {})}
      />
      {children ?? <EmptyState title={t('surface.placeholder')} />}
    </>
  );
}
